import React from "react";
import "./home2.css";
import { Link } from "react-router-dom";

import img1 from "../Images/home1.jpeg";
import img2 from "../Images/Project02.jpg";
import img3 from "../Images/Project03.jpg";
import img4 from "../Images/home2.jpeg";
import img5 from "../Images/Project01.jpg";
import img6 from "../Images/Project05.jpg";

function Home2() {
  const projects = [
    { img: img1, title: "View" },
    { img: img2, title: "View" },
    { img: img3, title: "View" },
    { img: img4, title: "View" },
    { img: img5, title: "View" },
    { img: img6, title: "View" },
  ];

  return (
    <>
      <div className="app">
        <h2 className="title">Our Recent Projects!</h2>

        <div className="project-grid">
          {projects.map((item, index) => (
            <div className="project-card" key={index}>
              <img src={item.img} alt={`Project ${index + 1}`} />

              <div className="overlay">
                <Link
                  to="/projects"
                  style={{
                    backgroundColor: "yellow",
                    padding: "18px 45px",
                    borderRadius: "40px",
                    fontSize: "28px",
                    textDecoration: "none",
                    fontWeight: "600",
                    color: "black",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                  }}
                >
                  View
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/94775728376"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="28"
          height="28"
          fill="currentColor"
        >
          <path d="M16 .4C7.3.4.2 7.4.2 16.2c0 2.8.7 5.5 2.1 7.9L0 32l8.2-2.2c2.4 1.3 5.1 2 7.8 2 8.8 0 15.8-7.1 15.8-15.8C31.8 7.4 24.8.4 16 .4zm0 28.8c-2.4 0-4.8-.6-6.9-1.8l-.5-.3-4.9 1.3 1.3-4.8-.3-.5c-1.3-2.2-2-4.7-2-7.3 0-7.6 6.2-13.8 13.8-13.8s13.8 6.2 13.8 13.8-6.2 13.8-13.8 13.8zm7.6-10.2c-.4-.2-2.4-1.2-2.8-1.3-.4-.2-.7-.2-1 .2-.3.4-1.1 1.3-1.3 1.6-.2.2-.5.2-.9 0s-1.7-.6-3.2-2c-1.2-1.1-2-2.4-2.2-2.8-.2-.4 0-.6.1-.8s.3-.4.4-.6c.2-.2.3-.4.4-.6.1-.2.1-.4 0-.6-.1-.2-1-2.4-1.3-3.3-.4-.9-.7-.8-1-.8h-.8c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.4 3.5c.2.3 2.4 3.7 5.8 5.1 3.4 1.5 3.4 1 4 1 .6 0 2-0.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.1-.4-.2-.8-.4z"/>
        </svg>
      </a>
    </>
  );
}

export default Home2;
